module.exports = __webpack_public_path__ + "static/img/8.6185694.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/zh/8.png
// module id = YqCs
// module chunks = 0